<template>
    <v-row no-gutters class="pb-1"> 
        <v-col cols="12" md="4" class="pe-1">
            <v-autocomplete
                label="item"
                v-model="line.item_id"
                :rules="[isRequired]"
                outlined
                dense
                hide-details="auto"
                :items="items"
                item-text="display_name"
                item-value="id"
                :loading="itemLoading"
                @update:search-input="handleItemSearchInput"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="">
            <v-select
                label="Unit"
                v-model="line.measure_unit_id"
                :rules="[isRequired]"
                dense
                outlined
                :items="measureUnits"
                item-text="abbreviation"
                item-value="id"
                hide-details="auto">
            </v-select>
        </v-col>
        <v-col cols="12" md="1" class="ps-1 pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                label="Price"
                v-model="line.price"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <v-text-field
                label="Subtotal"
                :value="line.subtotal"
                background-color="disabled"
                disabled
                outlined
                dense
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class=""> 
            <v-select
                label="Tax"
                :rules="[isRequired]"
                :items="taxRates"
                item-text="name"
                item-value="id"
                v-model="line.tax_id"
                outlined
                dense
                hide-details="auto"
            >
            </v-select>
        </v-col>
        <v-col cols="12" md="2" class="ps-1 pe-1">
            <div class="d-flex align-center justify-center">
            <v-text-field
                label="Total"
                :value="line.total"
                dense
                outlined
                hide-details="auto"
                disabled
                background-color="disabled"
            >
            </v-text-field>
            <v-btn icon @click="handleDeleteLine">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric} from "./../../utils/validations"
import { mapGetters, mapActions } from 'vuex'
export default {
    props: {
        value: Object
    },
    data(){
        return {
            line: {},
            itemQuery: "",
            itemLoading: false
        }
    },
    watch: {
        line: {
            deep: true,
            handler() {
                this.$emit("input", {...this.line})
            }
        },
        subtotal(value) {
            this.line.subtotal = value
        },
        taxAmount(value) {
            this.line.tax = value
        },
        total(value) {
            this.line.total = value
        }
    },
    computed:{
        ...mapGetters({
            items: "purchase/item/list",
            taxRates: "purchase/tax/list",
        }),

        /**
         * The currently selected item.
         */
        selectedItem() {
            return this.items.find(e => e.id == this.line.item_id)
        },

        /**
         * Item Measure Units - each item has specific measure units.
         * @returns {Array} Item Measure Unit 
         */
        measureUnits() {
            if(!this.selectedItem) return [];

            let measureUnits = this.selectedItem.measure_units;            
            return Array.isArray(measureUnits) ? measureUnits : [];
        },
        subtotal() {
            let subtotal = this.line.quantity * this.line.price;
            return isNaN(subtotal) ? 0 : subtotal;
        },

        // find the selected tax object from array of taxs rates
        /**
         * @returns tax object  
         */
        selectedTax() {
            return this.taxRates.find(e => e.id == this.line.tax_id);
        },

        /**
         * @returns tax Amount  
         */
        taxAmount() {
            return this.selectedTax ? this.subtotal * this.selectedTax.rate : 0;
        },

        total() {
            let total = this.subtotal + this.taxAmount;
            return isNaN(total) ? 0 : total;
        },
    },
    methods: {
        isRequired, isNumeric,
        handleDeleteLine() {
            this.$emit('delete:line')
        },
        ...mapActions({
            itemSearch: "purchase/item/search"
        }),
        async handleItemSearchInput(val) {
            this.itemLoading = true;
            await this.itemSearch(val);
            this.itemLoading = false;
        }
    },
    mounted() {
        this.line = {...this.value, subtotal: 0, total: 0, tax: 0};
    }
}
</script>

<style>

</style>